import {z} from 'zod';

export const testDriveStateSchema = z.enum(['planned', 'completed', 'cancelled']);
export type TestDriveState = z.infer<typeof testDriveStateSchema>;

export const testDriveDocumentResponseSchema = z.object({
  id: z.string(),
  filename: z.string(),
  pdfFilename: z.string(),
  fileUri: z.string(),
  pdfUri: z.string(),
  uploadedAt: z.string(),
});
export type TestDriveDocumentResponseBody = z.infer<typeof testDriveDocumentResponseSchema>;

export const testDriveResponseSchema = z.object({
  id: z.string(),
  businessCaseId: z.string().nullable(),
  businessCaseCode: z.string().nullable(),
  vehicleId: z.string(),
  userId: z.string(),
  userFirstName: z.string(),
  userLastName: z.string(),
  customerId: z.string(),
  customerFoundingPersonFirstName: z.string().nullable(),
  customerFoundingPersonLastName: z.string().nullable(),
  customerTradeName: z.string().nullable(),
  state: testDriveStateSchema,
  note: z.string().nullable(),
  internalNote: z.string().nullable(),
  customerFeedback: z.string().nullable(),
  customerName: z.string().nullable(),
  customerDriversLicence: z.string().nullable(),
  fuelBefore: z.number().nullable(),
  fuelAfter: z.number().nullable(),
  mileageBefore: z.number().nullable(),
  mileageAfter: z.number().nullable(),
  returnedAt: z.string().nullable(),
  scheduledAt: z.string(),
  createdAt: z.string(),
  createdBy: z.string(),
  updatedAt: z.string().nullable(),
  updatedBy: z.string().nullable(),
  documents: z.array(testDriveDocumentResponseSchema),
});
export type TestDriveResponseBody = z.infer<typeof testDriveResponseSchema>;

export const createTestDriveRequestSchema = z.object({
  userId: z.string(),
  state: testDriveStateSchema,
  note: z.string().nullable(),
  scheduledAt: z.string(),
  fuelBefore: z.number().nullable().optional(),
  fuelAfter: z.number().nullable().optional(),
  mileageBefore: z.number().nullable().optional(),
  mileageAfter: z.number().nullable().optional(),
  returnedAt: z.string().nullable().optional(),
  vehicleId: z.string().nullable().optional(),
  internalNote: z.string().nullable().optional(),
  customerFeedback: z.string().nullable().optional(),
  customerName: z.string().nullable().optional(),
  customerDriversLicence: z.string().nullable().optional(),
});
export type CreateTestDriveRequestBody = z.infer<typeof createTestDriveRequestSchema>;

export const getTestDriveArgSchema = z.object({
  businessCaseId: z.string(),
});
export type GetTestDriveApiArg = z.infer<typeof getTestDriveArgSchema>;

export const createTestDriveArgSchema = z.object({
  businessCaseId: z.string(),
  createTestDriveRequestBody: createTestDriveRequestSchema,
});
export type CreateTestDriveApiArg = z.infer<typeof createTestDriveArgSchema>;

export type GetTestDriveApiResponse = TestDriveResponseBody;
export type CreateTestDriveApiResponse = TestDriveResponseBody;

export type ListTestDriveApiResponse = /** status 200  */ TestDriveResponseBody[];
export const listTestDriveApiArgSchema = z.object({
  businessCaseId: z.string(),
});
export type ListTestDriveApiArg = z.infer<typeof listTestDriveApiArgSchema>;
